import { CSSProperties, FC, ReactNode } from 'react';

import OverflowFadeScrollArea from '@/shared/components/layouts/OverflowFadeScrollArea';

export interface SearchFilterSectionOverflowProps {
    children: ReactNode;
    maxHeight?: CSSProperties['maxHeight'];
}

/** Bounded filter-section content shared by Search's collapsible filter surfaces. */
const SearchFilterSectionOverflow: FC<SearchFilterSectionOverflowProps> = ({ children, maxHeight = '25rem' }) => (
    <OverflowFadeScrollArea containerStyle={{ maxHeight }} surface='base'>
        {children}
    </OverflowFadeScrollArea>
);

export default SearchFilterSectionOverflow;
